import React from "react";
import { InputDate } from "../../../../../controls";
import { subDays } from "date-fns";
import moment from "moment";

const MfgAndExpDateInput = ({ prod, setValues }) => {
  const handleInpChg = (name, value) => {
    setValues((j) => ({
      ...j,
      stockProds: j.stockProds.map((x) => {
        if (x.prodId === prod.prodId && x.varProdId === prod.varProdId) {
          return {
            ...x,
            [name]: value,
          };
        }

        return {
          ...x,
        };
      }),
    }));
  };

  const compactStyle = {
    "& .MuiInputBase-root": {
      height: 25,
      fontSize: "0.8rem",
    },
    "& .MuiOutlinedInput-input": {
      padding: "0px 6px 0px 6px",
    },
    "& .MuiInputLabel-root": {
      fontSize: "0.7rem",
      transform: "translate(14px, 6px) scale(1)",
    },
    "& .MuiInputLabel-shrink": {
      transform: "translate(14px, -9px) scale(0.75)",
    },
    "& .MuiSvgIcon-root": {
      width: "0.65em",
      height: "0.65em",
    },
    "& .MuiButtonBase-root": {
      padding: "2px",
    },
    width: "130px",
  };

  return (
    <div className="flex flex-col items-center justify-center gap-1">
      <InputDate
        placeholder="MFG Date"
        variant="outlined"
        size="small"
        name="mfgDate"
        value={prod.mfgDate}
        views={["day", "month", "year"]}
        openTo="day"
        minDate={new Date("01/01/2015")}
        maxDate={subDays(new Date(), 1)}
        onChange={(date) =>
          handleInpChg("mfgDate", new Date(date).toLocaleDateString())
        }
        sx={{
          ...compactStyle,
        }}
      />

      <InputDate
        placeholder="EXP Date"
        variant="outlined"
        size="small"
        name="expDate"
        value={prod.expDate}
        minDate={moment(prod.mfgDate, "MM/DD/YYYY").add(1, "days")}
        views={["day", "month", "year"]}
        openTo="day"
        onChange={(date) =>
          handleInpChg("expDate", new Date(date).toLocaleDateString())
        }
        sx={{
          ...compactStyle,
        }}
      />
    </div>
  );
};

export default MfgAndExpDateInput;
